import {Component, computed, inject} from '@angular/core';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {TranslocoDirective} from '@jsverse/transloco';
import {Step31SystemRecordingEditorComponent} from './step-3-1-system-recording-editor/step-3-1-system-recording-editor.component';
import {Step31SystemOverviewComponent} from './step-3-1-system-overview/step-3-1-system-overview.component';
import {TabStatusEnum} from '../../../../../../shared/tabs/tab-status.model';
import {TabStatusDirective} from '../../../../../../shared/tabs/tab-status.directive';
import {StepDotMenuComponent} from '../../../../../../shared/components/step-dot-menu/step-dot-menu.component';
import {
  ProjectRoleType,
  ProjectStepType,
  SystemRecordingsOverviewControllerService,
} from '@frontend/shared';
import {SystemRecordingLegendComponent} from '../shared/components/system-recording-legend/system-recording-legend.component';
import {CardTitleComponent} from '../../../../../../shared/components/header/card-title/card-title.component';
import {ProjectStepBaseReactive} from '../../../project-base-step/project-base-step-reactive.component';
import {LoadingComponent} from '../../../../../../shared/components/loading/loading.component';
import {rxResource} from '@angular/core/rxjs-interop';
import {SystemRecordingStateService} from './system-recording-state.service';
import {TabsUnsavedRevealDirective} from '../../../../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  selector: 'app-step-3-1-system-recording',
  imports: [
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    TranslocoDirective,
    Step31SystemRecordingEditorComponent,
    Step31SystemOverviewComponent,
    StepDotMenuComponent,
    SystemRecordingLegendComponent,
    CardTitleComponent,
    LoadingComponent,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './step-3-1-system-recording.component.html',
})
export class Step31SystemRecordingComponent extends ProjectStepBaseReactive {
  protected readonly ProjectStepType = ProjectStepType;
  protected readonly ProjectRoleType = ProjectRoleType;

  private readonly systemRecordingsOverviewController = inject(
    SystemRecordingsOverviewControllerService,
  );
  private readonly systemRecordingStateService = inject(SystemRecordingStateService);

  protected readonly currentOfficeSystemRecordingResource = rxResource({
    params: () => ({
      projectId: this.projectId()!,
      dataSaved: this.systemRecordingStateService.dataSavedTrigger(),
    }),
    stream: ({params: request}) => {
      return this.systemRecordingsOverviewController.getCurrentSystemRecordingsOverview({
        projectId: request.projectId,
      });
    },
  });

  protected readonly targetOfficeSystemRecordingResource = rxResource({
    params: () => ({
      projectId: this.projectId()!,
      dataSaved: this.systemRecordingStateService.dataSavedTrigger(),
    }),
    stream: ({params: request}) => {
      return this.systemRecordingsOverviewController.getTargetSystemRecordingsOverview({
        projectId: request.projectId,
      });
    },
  });

  getTabStatusClass = computed(() => {
    if (this.stepState.isCurrentStepFinished()) return TabStatusEnum.COMPLETED;
    if (this.stepState.isCurrentStepInProgress()) return TabStatusEnum.IN_PROGRESS;
    return TabStatusEnum.NOT_STARTED;
  });

  detailTabsDisabled = computed(() => {
    if (this.stepState.isCurrentStepFinished()) return false;
    if (this.stepState.isCurrentStepInProgress()) return false;
    return true;
  });
}
